import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 41.39 40.23" width="6em" height="6em" {...props}>
    <path
      d="M35.16 25.96c-.19-.14-.46-.27-.49-.44-.44-2.38-.84-4.78-1.27-7.16-.13-.7-.4-1.37-.5-2.07-.29-2.05-.36-4.15-.84-6.16-.42-1.76-1.27-3.42-1.9-5.04l-.5.2c-.77.3-1.39.52-1.97.8-1.18.58-2.31 1.28-3.51 1.82-1.48.66-3.03 1.15-4.5 1.8-1.19.53-2.29 1.23-3.46 1.76-1.29.58-2.65.98-3.92 1.57a8.2 8.2 0 0 0-2.34 1.48 15.94 15.94 0 0 1-4.85 3.04c-.17.37-.47.74-.46 1.1 0 .05-.24.43-.25.48 0 1.13-.47 1.3-1.38 1.8-1.02.54-2.27.5-2.97.98 1.15 1.34 3.1 2.49 4.54 3.35.28.17.6.32.92.38 1.85.38 3.72.66 5.55 1.11 2.62.65 5.49.42 7.8 2.16.1.07.25.05.37.09 2.38.72 4.74 1.46 7.12 2.16 1.15.34 2.32.8 3.5.86 1.57.08 3.17-.11 4.73-.32.34-.05.85-.69.85-1.05 0-1.57-.17-3.14-.27-4.7"
      fill="#87465b"
    />
    <path
      d="M24.46 15.2c-.7-.78-1.63-1.51-3.92-1.53-.9 0-2.27.2-3.33 1.33a3.45 3.45 0 0 0-.98 2.94c.03.3.46.66.16 1.25 0 0-.66 1.15-.64 1.34 0 0 0 .35.53.36 0 0 .14.02.1.32v.44s.01.13.25.2c0 0 .05.05-.02.14 0 0-.13.14.09.44.08.1.2.25.13.53 0 0-.1.55.11.68 0 0 .25.29 1.23.17.34-.04.98-.21 1.36.26 0 0 .9 1.72.97 2.13 0 0 1.54-2.75 3.43-3.17 0 0-.46-1.04.47-2.38 0 0 1.17-1.54 1.2-2.4 0 0 .32-1.42-1.14-3.05z"
      fill="none"
      stroke="currentColor"
      strokeWidth={0.368}
      strokeMiterlimit={10}
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/bouton-personnage-2.svg